<fieldset>
  <label class="wizard-label" [for]="name">{{ label }}</label>

  <input type="text" [placeholder]="placeholder" [name]="name" [(ngModel)]="value" (ngModelChange)="find($event)" />

  <agm-map
    style="height: 500px; margin-top: 1.5em; display: block"
    (mapReady)="getMap($event)"
    mapTypeControl
    [latitude]="result?.latitude || location?.latitude"
    [longitude]="result?.longitude || location?.longitude"
    [zoom]="(result && result.latitude) || (location && location.latitude) ? 8 : 2"
  >
    <agm-marker
      *ngIf="(result && result.latitude) || (location && location.latitude)"
      [latitude]="result?.latitude || location?.latitude"
      [longitude]="result?.longitude || location?.longitude"
      [iconUrl]="'/assets/gfx/icon-marker.svg'"
    ></agm-marker>
  </agm-map>

  <div style="margin-top: 0.62em" *ngIf="(result && result.name) || (location && location.name)">
    <button type="button" (click)="reset()">
      <span class="icon icon--right is--icon-close">
        <svg class="icon-close">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/gfx/svg-sprite.svg#icon-close"></use>
        </svg>
      </span>
    </button>
    &nbsp;
    <span>{{ result.name || location.name }}</span>
  </div>
</fieldset>
